import { render, staticRenderFns } from "./OrgApprove.vue?vue&type=template&id=1191b96b"
import script from "./OrgApprove.vue?vue&type=script&lang=js"
export * from "./OrgApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1191b96b')) {
      api.createRecord('1191b96b', component.options)
    } else {
      api.reload('1191b96b', component.options)
    }
    module.hot.accept("./OrgApprove.vue?vue&type=template&id=1191b96b", function () {
      api.rerender('1191b96b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/OrgApprove.vue"
export default component.exports